import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../Form/FormField";
import FormDate from "../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {withStyles} from "@material-ui/core";
import {getPersonName, mergeWithDefault} from "../Form/utils";
import FormCheck from "../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../Form/DeleteButton";
import FormSelect from "../Form/FormSelect";
import Divider from '@material-ui/core/Divider';
import MediaDropButton from '../Media/DropButton';

class PersonsFormFields extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
        };
    }

    render() {
        const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            personType,
            setFieldValue,
            formUrl,
            isEdit,
            uploadConfig,
            setFormikState,
        } = this.props;

        return (
            <form
                method="POST"
                url={formUrl}
                onSubmit={handleSubmit}
            >

                <input type="hidden" name="person_type" value={values.person_type} onChange={handleChange}/>

                <Grid container spacing={24} alignItems="center">
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            autoComplete={false}
                            name="search_value"
                            label={i18n.get('persons.search_value')}
                            label_exclaim={i18n.get('persons.search_value_explain')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.search_value}
                            error={errors.search_value}
                            touched={touched.search_value}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>

                    <Grid item xs={12} sm={2}>
                        <FormSelect
                            type="text"
                            name="salutation"
                            label={i18n.get('persons.salutation')}
                            onChange={option => setFieldValue('salutation', option.value)}
                            onBlur={handleBlur}
                            value={values.salutation}
                            error={errors.salutation}
                            touched={touched.salutation}
                            options={[
                                {label: 'Herr', value: 'Herr'},
                                {label: 'Frau', value: 'Frau'}
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FormField
                            type="text"
                            name="title"
                            label={i18n.get('persons.title')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title}
                            error={errors.title}
                            touched={touched.title}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            name="first_name"
                            label={i18n.get('persons.first_name')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.first_name}
                            error={errors.first_name}
                            touched={touched.first_name}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            name="last_name"
                            label={i18n.get('persons.last_name')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.last_name}
                            error={errors.last_name}
                            touched={touched.last_name}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FormLabel component="legend">{i18n.get('persons.gender')+ ':'}</FormLabel>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FormControl component="fieldset">
                            <RadioGroup
                                aria-label={i18n.get('persons.gender') }
                                name="gender"
                                value={values.gender}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            >
                                <FormControlLabel value="männlich" control={<Radio color={"default"}/>} label="Männlich"/>
                                <FormControlLabel value="weiblich" control={<Radio color={"default"}/>} label="Weiblich"/>
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FormDate
                            type="date"
                            name="birthday"
                            label={i18n.get('persons.birthday')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.birthday}
                            error={errors.birthday}
                            touched={touched.birthday}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormField
                            type="text"
                            name="citizenship"
                            label={i18n.get('persons.citizenship')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.citizenship}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormField
                            type="text"
                            name="denomination"
                            label={i18n.get('persons.denomination')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.denomination}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>

                    <Grid item xs={12}>
                        <FormLabel component="legend">{i18n.get('persons.address')}</FormLabel>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FormField
                            type="text"
                            name="street"
                            label={i18n.get('persons.street')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.street}
                            error={errors.street}
                            touched={touched.street}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <FormField
                            type="text"
                            name="housenumber"
                            label={i18n.get('persons.housenumber')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.housenumber}
                            error={errors.housenumber}
                            touched={touched.housenumber}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <FormField
                            type="text"
                            name="zip"
                            label={i18n.get('persons.zip')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.zip}
                            error={errors.zip}
                            touched={touched.zip}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FormField
                            type="text"
                            name="city"
                            label={i18n.get('persons.city')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.city}
                            error={errors.city}
                            touched={touched.city}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>

                    <Grid item xs={12}>
                        <FormLabel component="legend">{i18n.get('persons.contact_data')}</FormLabel>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            name="telephone"
                            label={i18n.get('persons.telephone')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.telephone}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            name="mobile"
                            label={i18n.get('persons.mobile')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.mobile}
                        />
                    </Grid>
                    <Grid item xs={false} sm={4}>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="email"
                            name="email"
                            label={i18n.get('persons.email')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            name="website"
                            label={i18n.get('persons.website')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.website}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            name="company_name"
                            label={i18n.get('persons.company')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.company_name}
                            error={errors.company_name}
                            touched={touched.company_name}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            name="department"
                            label={i18n.get('persons.department')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.department}
                            error={errors.department}
                            touched={touched.department}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormAutocomplete
                            name="qualification_id"
                            label={i18n.get('persons.qualification')}
                            url="/search-qualification"
                            onChange={option => {
                                values.qualification_id = option.value;
                                if ( option.entity ) {
                                    values.qualification = option.entity
                                }
                                setFormikState({values});
                            }}
                            onBlur={handleBlur}
                            defaultOptions={values.qualification && [{
                                'value': values.qualification.id,
                                'label': values.qualification.name,
                                'entity': values.qualification,
                            }]}
                            value={values.qualification && {
                                'value': values.qualification.id,
                                'label': values.qualification.name,
                                'entity': values.qualification,
                            }}
                            error={errors.qualification_id}
                        />
                    </Grid>

                    {/*<MediaDropButton*/}
                        {/*uploadConfig={uploadConfig}*/}
                        {/*onNewFile={(file) => {*/}
                            {/*values.files.push(file);*/}
                            {/*setFieldValue('files', values.files);*/}
                        {/*}}*/}
                    {/*/>*/}

                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                </Grid>

                <Grid container spacing={24} justify="space-between" alignItems="center" style={{paddingTop: 8}}>
                    <Grid item>
                        {isEdit && (
                            <DeleteButton
                                href={`/persons/${values.id}`}
                                confirmMessage={i18n.get('persons.confirm_message')}
                                successMessage={i18n.get('persons.delete_success_message')}
                                handleSuccess={() => {history.go(-1)}}
                            />
                        )}
                    </Grid>
                    <Grid item>
                        <Button size="small"
                                variant="contained"
                                color="primary"
                                type="submit"
                        >
                            {isEdit ?
                                (<Icon fontSize="small">refresh</Icon>) :
                                (<Icon fontSize="small">save</Icon>)
                            } &nbsp;
                            {isEdit ? i18n.get('persons.update') : i18n.get('persons.save')}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        )
    }
}

export default PersonsFormFields



// WEBPACK FOOTER //
// ./resources/assets/js/components/Persons/PersonsFormFields.js